<h2 mat-dialog-title>{{ 'phoneme.fall-back-to-phoneme' | translate}}:</h2>
<mat-dialog-content>
  <app-phonemes-menu [isDialog]="true" (chosenPhonemeEvent)="savePhonemeLocally($event)"></app-phonemes-menu>
</mat-dialog-content>
<mat-dialog-actions class="ti-fall-back-to-phoneme__button-panel">
  <button mat-raised-button mat-dialog-close>{{'COMMON.cancel' | translate}}</button>
  <button mat-raised-button color="accent" [mat-dialog-close]="phoneme" [disabled]="!phoneme">{{'COMMON.save' | translate}}</button>
</mat-dialog-actions>
